import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { GovernanceProvider } from './context/GovernanceContext';
import AuthGate from './components/auth/AuthGate';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthGate>
      <GovernanceProvider>
        <App />
      </GovernanceProvider>
    </AuthGate>
  </React.StrictMode>
);
